module.exports = __webpack_public_path__ + "static/image_2-346833c34a5c8c5f66ffd42c8c49bd47.jpg";